// // css文件中不要使用import
// import '../css/reset.css';
// import '../css/whatever.css';
// import '../css/video-js.css';

// import './lib/object.assign';
// import './lib/promise';
import videojs from 'video.js';
import 'videojs-flash';
import 'videojs-contrib-hls';
window.webvideojs = videojs;
// import React, {Component} from 'react';
// import ReactDOM, {render} from 'react-dom';
// import { Router, Route, hashHistory, useRouterHistory} from 'react-router';

// class App extends Component {
//     componentDidMount(){
//         let player = webvideojs('J_Video', {
//             techOrder: ['flash', 'html5'], // 兼容順序
//             flash: {
//                 swf: '//h.cdn.pengpengla.com/up/uplive-obs/1.0.1/video-js.swf',
//             },
//             poster: 'http://p.cdn.upliveapps.com/uplive/p/u/2018/8/29/7fd2f5d2-1022-4f85-89a6-af91e9fb249d_600_600.jpg',
//             sources: [{
//                 // type: 'rtmp/mp4',
//                 // src: 'rtmp://wspull.upliveapp.com/ws/9_853037571198565744642887553c_8-4148915867947630592c70429b2_9'
//             },{
//                 type: 'video/x-flv',
//                 src: 'http://wsflv.upliveapp.com/ws/9_853037571198565744642887553c_8-4148915867947630592c70429b2_9.flv'
//             }, {
//                 type: 'application/x-mpegURL',
//                 src: 'http://wshls.upliveapp.com/ws/6_87523881107352190976260ae3b5_82275750475473092608fd751936_6/playlist.m3u8'
//             }]
//         });
//         window.player = player;
//         player.play();

//     }
    
//     render() {
//         return (
//             <div>
//                 <video id="J_Video" className="video-js" controls preload="auto">
//                     <p className="vjs-no-js">
//                         To view this video please enable JavaScript, and consider upgrading to a web browser that
//                         <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
//                     </p>
//                 </video>
//            </div>
//         );
//     }
// }

// render(<App />, $('#wrap')[0]); 



// WEBPACK FOOTER //
// ./js/app.js